module.exports = __webpack_public_path__ + "assets/img/ICI-UK-Content-Marketing-w960.40e6c61f.webp";